// extracted by css-extract-rspack-plugin
export default {"wrapper":"m8yzSnYFUIV2o__S","tableContainer":"opN5kkQRXGcb_LbR"};